import React, { FC } from "react";

const FullWidth: FC = ({ children }) => {
  return <div className="-mx-2 md:-mx-10 -my-2.5 md:-my-9">{children}</div>;
};

export default FullWidth;
